export const ListSource = [
    {name: "Marketing", value: 1},
    {name: "Khác", value: 100}
]

export const tabComponent = [
    {type: 'lead', id: 'leadPage', title: 'Quản lý lead', icon: 'star'},
    {type: 'dashboard', id: 'dashboardPage', title: 'Dashboard', icon: 'home'},
    {type: 'appointment', id: 'appointmentPage', title: 'Quản lý lịch hẹn', icon: 'event_note'},
    {type: 'task', id: 'taskPage', title: 'Quản lý task', icon: 'assignment_turned_in'},
    {type: 'campaign', id: 'campaignPage', title: 'Quản lý campaign'},
    {type: 'contact', id: 'contactPage', title: 'Danh sách liên hệ'},
    {type: 'settingUser', id: 'settingUserPage', title: 'Quản lý user'},
    {type: 'settingTenant', id: 'settingTenantPage', title: 'Quản lý tenant'},
    {type: 'settingTenantDealer', id: 'settingTenantDealerPage', title: 'Quản lý tenant đại lý'},
    {type: 'oaChat', id: 'zaloOaChat', title: 'Zalo Chat'},
    {type: 'messenger', id: 'fbMessenger', title: 'Facebook messenger'},
    {type: 'splitData', id: 'splitData', title: 'Kho Lead'},
    {type: 'assignLead', id: 'assignLead', title: 'Chia dữ liệu Lead'},
    {type: 'leadControlManager', id: 'leadControlManager', title: 'Kiểm soát Lead tổng hợp'},
    {type: 'leadControl', id: 'leadControl', title: 'Kiểm soát Lead chi tiết'},
    {type: 'leadHistory', id: 'leadHistory', title: 'Báo cáo Lead'},
    {type: 'customers', id: 'customers', title: 'Quản lý khách hàng'},
    {type: 'customersHub', id: 'customersHub', title: 'Quản lý khách hàng'},
    {type: 'phoneNumberHub', id: 'phoneNumberHub', title: 'Quản lý đầu số'},
    {type: 'cases', id: 'cases', title: 'Quản lý Cases'},
    {type: 'tickets', id: 'tickets', title: 'Quản lý đơn hàng'},
    {type: 'reportPhoneOut', id: 'reportPhoneOut', title: 'Báo cáo chi tiết cuộc gọi'},
    {type: 'reportAgent', id: 'reportAgent', title: 'Báo cáo năng suất Agent'},
    {type: 'reportAgentV1', id: 'reportAgentV1', title: 'Báo cáo năng suất gọi trực tiếp'},
    {type: 'reportAgentV2', id: 'reportAgentV2', title: 'Báo cáo năng suất gọi CRM'},
    {type: 'reportCampaign', id: 'reportCampaign', title: 'Campaign nháy máy'},
    {type: 'reportSaleProcess', id: 'reportSaleProcess', title: 'Báo cáo toàn trình KD'},
    {type: 'reportSale', id: 'reportSale', title: 'Báo cáo sale - tạm chốt'},
    {type: 'reportSaleFinish', id: 'reportSaleFinish', title: 'Báo cáo sale - chốt'},
    {type: 'reportTechTotal', id: 'reportTechTotal', title: 'Báo cáo kỹ thuật tổng hợp'},
    {type: 'reportTech', id: 'reportTech', title: 'Báo cáo kỹ thuật chi tiết'},
    {type: 'reportOrder', id: 'reportOrder', title: 'Báo cáo kỹ thuật đơn hàng'},
    {type: 'reportKeyClick', id: 'reportKeyClick', title: 'Báo cáo chi tiết phím bấm'},
    {type: 'reportPredictive', id: 'reportPredictive', title: 'Báo cáo chiến dịch gọi tự động'},
    {type: 'reportPredictiveV1', id: 'reportPredictiveV1', title: 'Báo cáo chiến dịch gọi tự động V1'},
    {type: 'reportPredictiveTTSV1', id: 'reportPredictiveTTSV1', title: 'Autocall Predictive TTS V1'},
    {type: 'monitoring', id: 'monitoring', title: 'Giám sát thời gian thực'},
    {type: 'reportLeadByStatus', id: 'reportLeadByStatus', title: 'Báo cáo lead theo trạng thái'},
    {type: 'reportByDay', id: 'reportByDay', title: 'Báo cáo trạng thái lead theo ngày'},
    {type: 'reportByStaff', id: 'reportByStaff', title: 'Báo cáo trạng thái lead theo nhân viên'},
]

export const LIST_MENU = [
    {link: 'customers-hub', role: 'menu.customerhub'},
    {link: 'phone-number-hub', role: 'menu.manage.phoneNumber'},
    {link: 'check-hotline-number', role: 'menu.hotline.checkHotline'},
    {link: 'report-call-fee', role: 'menu.report.call.fee'},
    {link: 'report-call-fee-new', role: 'menu.report.call.fee.new'},
    {link: 'report-hub-phone-number', role: 'menu.report.hubPhoneNumber'},
    {link: 'report-hub-cust-phone-v2', role: 'menu.report.hub.CustPhone.v2'},
    {link: 'report-hub-cust-phone', role: 'menu.report.hub.CustPhone'},
    {link: 'report-detail-sub', role: 'menu.report.hub.sub.detail'},
    {link: 'report-call-detail', role: 'menu.customerhub.reportVoicemail'},
    {link: 'report-benefit', role: 'menu.report.benefit.by.sale'},
]

export const formatNumber = (number, n, x, s, c) => {
    if (!number || number === '' || typeof number !== 'number') {
        return number
    }
    let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')';
    let num = number.toFixed(Math.max(0, ~~n));

    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
}
